/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ActionFlow, CanLeave, ContainerState } from '@gh/common-shared';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { FormFlowState } from './form-actions.service';

export abstract class AbstractFormComponent<T> implements CanLeave {
  abstract form: ContainerState<T>;

  get processFlow(): ActionFlow<FormFlowState<T>> {
    return this.completeFlow;
  }

  get saveFlow(): ActionFlow<FormFlowState<T>> {
    return this.completeFlow;
  }

  get deactivateFlow(): ActionFlow<FormFlowState<T>> {
    return this.completeFlow;
  }

  get completeFlow(): ActionFlow<FormFlowState<T>> {
    throw new Error('Complete flow is not implemented. Either complete flow or all other flows should be implemented');
  }

  onProcess(): void {
    this.processFlow.run({
      trigger: 'process',
      form: this.form,
      value: this.form.submitValue,
    });
  }

  canDeactivate(): Observable<boolean> | boolean {
    return this.deactivateFlow.run({
      trigger: 'deactivate',
      form: this.form,
      value: this.form.submitValue,
    }).toFinalState().pipe(map$((state: any) => state.confirmation));
  }

  isViewDirty(): boolean {
    return this.form.dirty;
  }
}
